'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _dec3, _class, _class2, _temp;
// import { Link } from 'react-router-dom';
// remove this one
// import { provideHooks } from 'redial';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _content = require('redux/modules/content');

var contentActions = _interopRequireWildcard(_content);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactKatex = require('react-katex');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _reactI18next = require('react-i18next');

var _reactTabs = require('react-tabs');

var _reactBootstrap = require('react-bootstrap');

var _language = require('redux/modules/language');

var languageActions = _interopRequireWildcard(_language);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoaded = contentActions.isLoaded,
    loadContent = contentActions.loadContent,
    loadWithOtherContentIds = contentActions.loadWithOtherContentIds;
// import 'katex/dist/katex.min.css';
// require('katex/dist/katex.min.css');

var loadRecentWords = languageActions.loadRecentWords;
var Content = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        _ref$params = _ref.params,
        id = _ref$params.id,
        language = _ref$params.language,
        location = _ref.location;

    // console.log("asyncConnect");
    // if (!isLoaded(getState())) {
    // }
    //Should check to be different!!!
    var promises = [];

    promises.push(dispatch(loadRecentWords(1, language)));
    promises.push(dispatch(loadWithOtherContentIds(id)));
    return _promise2.default.all(promises);
    // return dispatch(loadWithOtherContentIds(id));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    content: state.content.data,
    recentWords: state.language.data,
    // editing: state.widgets.editing,
    // error: state.widgets.error,
    // loading: state.widgets.loading
    user: state.auth.user
  };
}, (0, _extends3.default)({}, contentActions, languageActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Content, _Component);

  function Content() {
    (0, _classCallCheck3.default)(this, Content);
    return (0, _possibleConstructorReturn3.default)(this, (Content.__proto__ || (0, _getPrototypeOf2.default)(Content)).apply(this, arguments));
  }

  (0, _createClass3.default)(Content, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // require('katex/dist/katex.min.css');
      // this.forceUpdate();
    }
  }, {
    key: 'transform',
    value: function (_transform) {
      function transform(_x, _x2) {
        return _transform.apply(this, arguments);
      }

      transform.toString = function () {
        return _transform.toString();
      };

      return transform;
    }(function (node, index) {
      // convert <ul> to <ol>
      if (node.type === 'tag' && node.name === 'inlinemath') {
        node.name = 'InlineMath';
        return (0, _reactHtmlParser.convertNodeToElement)(node, index, transform);
      }
    })
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // require('../../theme/katex.css');
      var _props = this.props,
          t = _props.t,
          content = _props.content,
          recentWords = _props.recentWords,
          user = _props.user;

      var styles = require('./Home.scss');
      // require the logo image both from client and server
      var logoImage = require('./logo.png');

      // console.log("AAAAAAAA");
      // console.log(content);

      var language = this.props.params.language === undefined ? 'en' : this.props.params.language;
      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(_reactHelmet2.default, { title: content ? content.lesson ? content.lesson.name : "Content" : "Content" }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            _reactBootstrap.Grid,
            null,
            _react2.default.createElement(
              _reactBootstrap.Row,
              { className: 'show-grid' },
              _react2.default.createElement(
                _reactBootstrap.Col,
                { sm: 8, md: 8 },
                _config2.default.is_for_personal_purpose && content && content.lesson && content.lesson.userId !== null && content.lesson.userId !== -1 && _react2.default.createElement(
                  'p',
                  null,
                  'author: ',
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { bsSize: 'xsmall', href: '/profile/' + content.lesson.userId, onClick: function onClick(e) {
                        e.preventDefault();
                        _this2.props.history.push('/profile/' + content.lesson.userId);
                      } },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'glyphicon glyphicon-user' })
                  )
                ),
                content && content.lesson && _react2.default.createElement(
                  'h1',
                  null,
                  content.lesson.name
                ),
                content.active && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('b', { dangerouslySetInnerHTML: { __html: content.name } }),
                  _react2.default.createElement(
                    'div',
                    null,
                    content && (0, _reactHtmlParser2.default)(content.data, { decodeEntities: true, transform: function transform(node, index) {
                        if (node.type === 'tag' && node.name === 'span' && node.attribs.class === "math-q") {
                          // node.name = 'InlineMath';
                          // console.log("what");
                          // console.log(node);
                          // console.log(index);
                          return _react2.default.createElement(_reactKatex.InlineMath, { math: node.children[0].data.slice(2, -2) });
                        }

                        //Find image tag: <span><img src=\"content/lessons/28/obitan_1.PNG\" /></span>
                        if (node.type === 'tag' && node.name === 'img') {
                          // console.log(node);
                          if (node.attribs.src.startsWith('content/lessons/')) {
                            // console.log("matchedddd.....");
                            var newSrc = 'http://hochochoc.com/www/' + node.attribs.src; //should be dynamic.... by using env...

                            return _react2.default.createElement('img', { src: newSrc });
                          }
                        }
                      } })
                  ),
                  _react2.default.createElement('el', null)
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.Col,
                { sm: 4, md: 4, style: {
                    // backgroundColor: 'lightblue'
                  } },
                content && content.lesson && _react2.default.createElement(_components.SortableDisabled, (0, _extends3.default)({
                  content: content,
                  onChange: function onChange(position) {
                    console.log(position);
                    _this2.props.history.push('/' + language + '/content/' + content.lesson.contents[position].id);
                  }
                }, this.props))
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Grid,
            null,
            _react2.default.createElement(
              _reactBootstrap.Row,
              { className: 'show-grid' },
              user && _react2.default.createElement(
                _reactBootstrap.Col,
                { sm: 4, md: 4 },
                _react2.default.createElement(_components.SearchView, { onSubmit: function onSubmit(data) {
                    console.log("hey");
                    console.log(data);
                    // data.q => this.props.history.push()
                    data.language = data.language === undefined ? 'en' : data.language;
                    _this2.props.history.push('/' + language + '/translate/' + data.q + '/' + data.language);
                  } }),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  _reactBootstrap.Panel,
                  null,
                  _react2.default.createElement(
                    'h4',
                    null,
                    t('content.new_words')
                  ),
                  recentWords !== undefined && recentWords.map(function (item, i) {
                    return _react2.default.createElement(
                      'div',
                      null,
                      (language === 'vi' && item.definition || language === 'en') && _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                          'span',
                          null,
                          _react2.default.createElement(
                            'b',
                            null,
                            item.word,
                            ' (',
                            item.lang,
                            ')'
                          )
                        ),
                        ' ',
                        _react2.default.createElement(
                          'span',
                          null,
                          item.definition && _react2.default.createElement(
                            'span',
                            null,
                            ' ',
                            item.definition.map(function (data) {
                              var shortDefinition = data.definition + ' ' + (data.more_definition !== undefined ? data.more_definition : '');
                              var definition = shortDefinition.trim() !== '' ? shortDefinition.trim() : data.long_definition;
                              return _react2.default.createElement(
                                'span',
                                null,
                                ' ',
                                definition.substring(0, 40),
                                ' '
                              );
                            }),
                            ' '
                          ),
                          !item.definition && _react2.default.createElement(
                            'span',
                            null,
                            'No definitions'
                          )
                        ),
                        ' ',
                        _react2.default.createElement(
                          _reactBootstrap.Button,
                          { href: '/' + language + '/translate/' + item.word + '/' + item.lang, bsStyle: 'link', onClick: function onClick(e) {
                              e.preventDefault();
                              _this2.props.history.push('/' + language + '/translate/' + item.word + '/' + item.lang);
                            } },
                          'Xem...'
                        ),
                        _config2.default.is_for_personal_purpose && _react2.default.createElement(
                          _reactBootstrap.Button,
                          { href: '/newKnowledgeWithAShortSumary/' + item.word + '/' + item.lang, bsStyle: 'link', onClick: function onClick(e) {
                              e.preventDefault();
                              _this2.props.history.push('/newKnowledgeWithAShortSumary/' + item.word + '/' + item.lang);
                            } },
                          _config2.default.is_for_personal_purpose && "Create Content"
                        )
                      )
                    );
                  }),
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { href: '/' + language + '/knowledge/2', onClick: function onClick(e) {
                        e.preventDefault();
                        _this2.props.history.push('/' + language + '/knowledge/2');
                      } },
                    t('content.see_more')
                  )
                )
              )
            )
          ),
          _react2.default.createElement('div', null)
        )
      );
    }
  }]);
  return Content;
}(_react.Component), _class2.propTypes = {
  content: _propTypes2.default.object
}, _temp)) || _class) || _class) || _class);
exports.default = Content;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Content/Content.js
// module id = 1516
// module chunks = 0